// extracted by mini-css-extract-plugin
export var backBtn = "breadcrumb-navigation-module--backBtn--ZbKSh";
export var backToTop = "breadcrumb-navigation-module--backToTop--aUOvL";
export var breadcrumbNavigation = "breadcrumb-navigation-module--breadcrumbNavigation--hbTxA";
export var breadcrumbs = "breadcrumb-navigation-module--breadcrumbs--nKzoV";
export var divider = "breadcrumb-navigation-module--divider---hX2V";
export var mobileWidth = "1024px";
export var pageTitle = "breadcrumb-navigation-module--pageTitle--9o6EQ";
export var parentTitle = "breadcrumb-navigation-module--parentTitle--6MIjL";